










































































































































import { Component, Vue } from 'vue-property-decorator';

import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import {progress} from '@/script/progress';

import { 発注履歴照会型, 発注履歴照会依頼型, 発注履歴照会依頼バリデータ一覧 } from '@/type/purchaseorder/history';
import { ValidationResult } from '@/type/validation/result';

import ItemClassSelector from '@/components/item/ItemClassSelector.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import Timepicker from '@/components/datepicker/TimePicker.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import moment from 'moment';
import {loginModule} from '@/store/authentication/login';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';

@Component({
  components: {
    Datepicker,
    ItemClassSelector,
    ButtonPanel,
    IconButton,
    Timepicker,
    SenderSelector,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    WholesaleSelector,
  },
  filters: {
    dateFormat(value: Date): string {
      if (!value) {
        return '';
      }
      return moment(value).format('YYYY/MM/DD');
    },
  },
})
export default class ListPurchaseOrderHistories extends Vue {
  private アラートメッセージ: string | string[] | null = null;

  private 発注履歴一覧: 発注履歴照会型[] = [];
  private 発注履歴照会依頼: 発注履歴照会依頼型 | null = null;

  private 検索条件エラーレスポンス: ValidationResult = new ValidationResult(発注履歴照会依頼バリデータ一覧);

  private created(): void {
    moment.locale('ja');
    this.initialize();
  }

  private initialize() {
    this.発注履歴照会依頼 = {
      メーカー名: null,
      商品名カナ: null,
      発注日From: moment().startOf('month').toDate(),
      発注時刻From: null,
      発注日To: null,
      発注時刻To: null,
      納品指定日From: null,
      納品指定日To: null,
      発注方法区分: null,
      商品区分: null,
      卸コード: null,
      確定送信者コード: null,
    };
    if (!loginModule.管理者である) {
      this.発注履歴照会依頼.確定送信者コード = loginModule.利用者コードを取得する;
    }
    this.アラートメッセージ = null;
    this.発注履歴一覧 = [];
  }

  private beforeUpdate(): void {
    this.検索条件エラーレスポンス.validate(this.発注履歴照会依頼);
  }

  private 入力エラー判定(項目名: string): boolean {
    return this.検索条件エラーレスポンス.hasError(項目名);
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private APIアラートダイアログを開く(data: any) {
      this.アラートメッセージ = [data.message];
      if (data.errors !== null && data.errors !== undefined) {
        for (const エラー of data.errors) {
          this.アラートメッセージ = this.アラートメッセージ.concat(['・' + エラー]);
        }
      }
      this.$modal.show('アラート');
  }

  private async 検索する(): Promise<void> {
    if (!this.発注履歴照会依頼) {
      return;
    }
    this.発注履歴一覧 = [];
    await api.発注履歴を検索する(this.発注履歴照会依頼)
      .then((response: any) => {
        this.発注履歴一覧 = response.発注履歴一覧;
        if (this.発注履歴一覧.length === 0) {
          this.アラートメッセージ = '該当の発注履歴は存在しません';
          this.$modal.show('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = response.アラートメッセージ;
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.APIアラートダイアログを開く(error.data);
      });
  }

  private async 検索するハンドラ(): Promise<void> {
    if (this.検索条件エラーレスポンス.hasErrors) {
      this.アラートメッセージ = this.検索条件エラーレスポンス.getMessages();
      this.$modal.show('アラート');
      return;
    }
    await progress(this.検索する);
  }

  private async 出力する(): Promise<void> {
    if (!this.発注履歴照会依頼) {
      return;
    }
    await download.発注履歴照会一覧表を出力する('発注履歴照会一覧.xlsx', this.発注履歴照会依頼)
            .catch((error: any) => {
              this.APIアラートダイアログを開く(error.data);
            });
    this.ダイアログを閉じる('出力ダイアログ');
  }

  private async 出力するハンドラ(): Promise<void> {
    await progress(this.出力する);
  }

  private async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.検索条件エラーレスポンス.hasErrors) {
      this.アラートメッセージ = this.検索条件エラーレスポンス.getMessages();
      this.$modal.show('アラート');
      return;
    }
    this.ダイアログを開く('出力ダイアログ');
  }

  private クリアする(): void {
    this.initialize();
    this.ダイアログを閉じる('クリアダイアログ');
  }
}
